import { render } from "./TopCandidateDetailsCard.vue?vue&type=template&id=6bacb146&scoped=true"
import script from "./TopCandidateDetailsCard.vue?vue&type=script&lang=js"
export * from "./TopCandidateDetailsCard.vue?vue&type=script&lang=js"

import "./TopCandidateDetailsCard.vue?vue&type=style&index=0&id=6bacb146&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bacb146"]])

export default __exports__